import React from 'react';
export const FlagContext = React.createContext({});
FlagContext.displayName = 'FlagContext';
